// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"d849f20d","453":"dbd785c5","455":"565f3acb","868":"88a7e4e6","977":"5855b30a"}[chunkId] + ".chunk.js";
};